// App version - update this when releasing new versions
export const APP_VERSION = "1.5.13";
export const APP_NAME = "Ferie e Permessi";
